// extracted by mini-css-extract-plugin
module.exports = {"fitment":"az_U3b"};